import React from 'react';
import { Box, Heading, Text, Link } from '@chakra-ui/react';

export const TrapLeague = () => {
  return (
    <Box>
      <Text mb={4} color="black">
        This will be a 5-man team and individual league running for 11 weeks. Cash prizes will be awarded to individuals and teams. All ties split the cash prize money. A handicap system will make it much more competitive and fun for all levels of shooters and teams. Two team classes will compete for prizes, so teams of various skill levels could win (participation numbers permitting).
      </Text>

      <Heading as="h3" size="md" mb={3} color="black">How the league works:</Heading>
      <Text mb={4} color="black">
        Teams will shoot one round (25 targets) from the 16-yard line and one round (25 targets) from handicap yardage for a total of two rounds (50 targets) each week. Handicap yardage will be calculated based on team standings each week (after the initial bank week). Teams are paired with another team each week.
      </Text>

      <Text mb={4} color="black">
        If you plan to miss more than one week, individuals may shoot banks any night after 5:00 pm. Banks must be scored by an independent scorer (preferably by a league participant from another team). A maximum of three banks will be allowed (first night's bank plus two additional) to qualify for individual payouts. Substitute shooters may be used on a night if no banks are available for an individual.
      </Text>

      <Text mb={4} color="black">
        If you miss a week and do not have a bank available, a dog score will be used (individual's league average minus 2 targets). No make-ups are allowed.
      </Text>

      <Text mb={4} color="black">
        Individual prizes will be paid based on the total average (singles and handicap), and most 25-straights.
      </Text>

      <Text mb={4} color="black">
        Team prizes will be paid based on the overall average for each 5-person team. All Ties Split.
      </Text>

      <Heading as="h3" size="md" mb={3} color="black">League Costs:</Heading>
      <Text mb={4} color="black">
        One-time payment of $100 ($25 Golden Gun Club fee, $75 for cash prizes) paid separately from targets.
      </Text>

      <Text mb={4} color="black">
        <strong>Payment methods:</strong> Cash, Check, Venmo.
      </Text>

      <Text mb={4} color="black">
        <strong>Target Costs:</strong> Targets are purchased separately from GGC by each shooter based on GGC membership status.
      </Text>

      <Heading as="h3" size="md" mb={3} color="black">Questions about the league?</Heading>
      <Text mb={4} color="black">
        Email Mark Hachtel or Gregg Kay at <Link href="mailto:GGCTrapLeague@gmail.com" color="blue.500">GGCTrapLeague@gmail.com</Link>.
      </Text>

      <Text mb={4} color="black">
        To sign up find the signup form here and send the correct information via email.
      </Text>
    </Box>
  );
};